import { css, CSSObject, SimpleInterpolation } from 'styled-components';

interface ForcedColorsMediaFeatures {
  forcedColors?: 'active' | 'none';
  prefersColorScheme?: 'light' | 'dark';
}

const forcedColorsMedia = ({ forcedColors = 'active', prefersColorScheme = undefined }: ForcedColorsMediaFeatures = {}) => (first: TemplateStringsArray | CSSObject, ...interpolations: SimpleInterpolation[]) => {
  let msHighContrast: 'active' | 'none' | 'black-on-white' | 'white-on-black' = forcedColors;

  if (prefersColorScheme === 'light') {
    msHighContrast = 'black-on-white';
  }

  if (prefersColorScheme === 'dark') {
    msHighContrast = 'white-on-black';
  }

  return css`
    @media (-ms-high-contrast: ${msHighContrast}), (forced-colors: ${forcedColors}) ${prefersColorScheme ? `and (prefers-color-scheme: ${prefersColorScheme})` : ''} {
      ${css(first, ...interpolations)};
    }
  `;
};

export default forcedColorsMedia;
